import { apiClient } from './client';

/**
 * Submit contact form data to the API
 */
export const submitContactForm = async (formData: {
  name: string;
  email: string;
  subject: string;
  message: string;
}): Promise<{ success: boolean; message: string }> => {
  try {
    await apiClient.post('/contact-us/', formData);
    return { 
      success: true, 
      message: 'Thank you for your message. We will get back to you soon!' 
    };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { 
      success: false, 
      message: 'Failed to submit your message. Please try again later.' 
    };
  }
}; 